import React from 'react';
import { useSxStyles } from '../styles/sxStyles';
import Typography from '@mui/material/Typography';
import Paper from '@mui/material/Paper';
import Grid2 from "@mui/material/Grid2";
import {getCurrency} from "../config/utils";
import TextField from "@mui/material/TextField";
import FormControl from "@mui/material/FormControl";
import { PatternFormat } from "react-number-format";
import FormLabel from "@mui/material/FormLabel";
import useTheme from "@mui/material/styles/useTheme";
import useMediaQuery from "@mui/material/useMediaQuery";
import PaymentLocation from "./PaymentLocation";

const CheckData = (props) => {
    const paymentRequest = props.paymentRequest;
    const paymentFields = props.paymentFields;
    const setPaymentFields = props.setPaymentFields;
    const locations = props.locations;
    const user = props.user;
    const setLocation = props.setLocation;
    const classes = useSxStyles;
    const theme = useTheme();
    const smallScreen = useMediaQuery(theme.breakpoints.down('lg'));

    const handleName = (e) => {
        const val = e.target.value;
        if (val && val !== paymentRequest.payorName) {
            setPaymentFields({...paymentFields, payorName: val});
        }
    }

    const handleRoutingNumber = (values) => {
        if (values.value && values.value.length === 9) {
            setPaymentFields({...paymentFields, routingNumber: values.value});
        }
    }

    const handleAccountNumber = (e) => {
        const val = e.target.value;
        if (val && val.length > 3) {
            setPaymentFields({...paymentFields, bankAccountNumber: val});
        }
    }

    const handleEmail = (e) => {
        const val = e.target.value;
        if (val && val !== paymentRequest.email) {
            setPaymentFields({...paymentFields, email: val});
        }
    }

    const handlePhone = (values) => {
        if (values && values.value && values.value.length === 10) {
            const val = values.formattedValue;
            if (val !== paymentRequest.phone) {
                setPaymentFields({...paymentFields, phone: val});
            }
        }
    }

    return (<>
        <Paper variant='body1' elevation={3} sx={classes.controlPanel}>
            <Grid2 container spacing={2}>
                <Grid2
                    sx={{paddingLeft: '0', paddingTop: '1rem'}}
                    size={{
                        xs: 12,
                        sm: 6
                    }}>
                    <Typography component='span' variant='subtitle1' color='primary' sx={{fontSize: '1.2rem'}}>
                        Amount:
                    </Typography>
                    <Typography component='span' variant='subtitle2' color='textPrimary' sx={{fontSize: '1.2rem', marginLeft: '1rem'}}>
                        {getCurrency(paymentRequest.totalAmount)}
                    </Typography>
                </Grid2>
                <Grid2
                    size={{
                        xs: 12,
                        sm: 6
                    }}>
                    <FormControl fullWidth sx={[smallScreen ? {
                        marginLeft: '0'
                    } : {
                        marginLeft: '.5rem'
                    }]}>
                        <FormLabel shrink={true} required sx={{...classes.inputLabel, paddingTop: '0', marginTop: '0'}}>
                            Name on Account
                        </FormLabel>
                        <TextField
                            name='name'
                            variant='outlined'
                            fullWidth
                            defaultValue={paymentRequest.payorName}
                            onBlur={handleName}
                            slotProps={{
                                htmlInput: {sx: classes.textbox}
                            }}
                        />
                    </FormControl>
                </Grid2>
                <Grid2
                    sx={{paddingLeft: '0'}}
                    size={{
                        xs: 12,
                        sm: 6
                    }}>
                    <FormControl fullWidth sx={{marginLeft: '0'}}>
                        <FormLabel htmlFor='routingNumber' required shrink={true} sx={classes.inputLabel}>
                            Routing Number
                        </FormLabel>
                        <PatternFormat
                            id='routingNumber'
                            name='routingNumber'
                            customInput={TextField}
                            type='text'
                            autoComplete='off'
                            variant='outlined'
                            format='#########'
                            InputProps={{sx: {...classes.numberbox}}}
                            onValueChange={(values) => handleRoutingNumber(values)}
                        />
                    </FormControl>
                </Grid2>
                <Grid2
                    size={{
                        xs: 12,
                        sm: 6
                    }}>
                    <FormControl fullWidth sx={[smallScreen ? {
                        marginLeft: '0'
                    } : {
                        marginLeft: '.5rem'
                    }]}>
                        <FormLabel htmlFor='accountNumber' required shrink={true} sx={classes.inputLabel}>Bank Account Number</FormLabel>
                        <TextField
                            id='accountNumber'
                            name='accountNumber'
                            variant='outlined'
                            fullWidth
                            onBlur={handleAccountNumber}
                            slotProps={{
                                htmlInput: {sx: classes.textbox}
                            }}
                        />
                    </FormControl>
                </Grid2>
                <Grid2
                    sx={{paddingLeft: '0'}}
                    size={{
                        xs: 12,
                        sm: 6
                    }}>
                    <FormControl fullWidth>
                        <FormLabel shrink={true} sx={classes.inputLabel}>Email Address</FormLabel>
                        <TextField
                            name='email'
                            variant='outlined'
                            fullWidth
                            defaultValue={paymentRequest.email}
                            onBlur={handleEmail}
                            slotProps={{
                                htmlInput: {sx: classes.textbox}
                            }}
                        />
                    </FormControl>
                </Grid2>
                <Grid2
                    size={{
                        xs: 12,
                        sm: 6
                    }}>
                    <FormControl fullWidth sx={[smallScreen ? {
                        marginLeft: '0'
                    } : {
                        marginLeft: '.5rem'
                    }]}>
                        <FormLabel shrink={true} sx={classes.inputLabel}>Phone Number</FormLabel>
                        <PatternFormat
                            name='phone'
                            customInput={TextField}
                            type='text'
                            autoComplete='off'
                            variant='outlined'
                            format="(###) ###-####"
                            InputProps={{
                                sx: {...classes.numberbox}
                            }}
                            defaultValue={paymentRequest.phone}
                            onValueChange={(values) => handlePhone(values)}
                        />
                    </FormControl>
                </Grid2>
                { locations && locations.length > 0 &&
                    <Grid2
                        sx={{marginTop: '.5rem', paddingLeft: '0'}}
                        size={{
                            xs: 12,
                            sm: 6
                        }}>
                        <PaymentLocation locations={locations} user={user} setLocation={setLocation} />
                    </Grid2>
                }
            </Grid2>
        </Paper>
    </>);
}

export default CheckData;
